export const alignFull = () => {
  function setAlignFullCssVar() {
    // Get the viewport width
    const viewportWidth = window.innerWidth;

    // Get root element and its computed style
    let root = document.documentElement;
    let root_style = getComputedStyle(root);

    // Set --win-width css var
    let cssVarWinWidth = root_style.getPropertyValue('--win-width');
    if (viewportWidth + 'px' !== cssVarWinWidth) {

      root.style.setProperty('--win-width', viewportWidth + 'px');

      if (viewportWidth > 1536) {
        root.style.setProperty('--offset-width', viewportWidth - 1536 + (64 * 2) + 'px');
      } else if (viewportWidth > 1280) {
        root.style.setProperty('--offset-width', viewportWidth - 1280 + (64 * 2) + 'px');
      } else if (viewportWidth > 1024) {
        root.style.setProperty('--offset-width', viewportWidth - 1024 + (48 * 2) + 'px');
      } else if (viewportWidth > 768) {
        root.style.setProperty('--offset-width', viewportWidth - 768 + (32 * 2) + 'px');
      } else if (viewportWidth > 640) {
        root.style.setProperty('--offset-width', viewportWidth - 640 + (20 * 2) + 'px');
      } else {
        root.style.setProperty('--offset-width', '0px');
      }

    }

  }

  // on load
  setAlignFullCssVar();

  window.addEventListener('resize', function () {
    setAlignFullCssVar();
  });
};
